exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property{float:left;background-color:rgba(34,46,53,.5);padding-right:3px;padding-left:3px;text-align:right}.property .property-name{float:left;color:#9c9c9c;min-width:15%;padding-right:10px;padding-left:5px;padding-top:2px;margin-top:2px;text-align:left}.property .property-value{background-color:rgba(0,214,255,.08);text-align:right;padding:2px;margin:1px 0}.property:hover{background-color:rgba(41,58,68,.5)}.property .property-value.text{color:#fff7ea}.property .property-value.number{color:#fde4ff;font-size:11px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/propertygrid.css
// module id = 538
// module chunks = 0